import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { get } from 'lodash-es';
import { EventToolbox } from 'client/utils/event-toolbox';
import { PRICE_CHECKER_EVENTS } from 'site-modules/shared/constants/price-checker';
import { StyledSelect } from 'site-modules/shared/components/styled-select/styled-select';

import { TOGGLE_MSG, TOGGLE_ERROR_MSG } from 'site-modules/shared/constants/price-checker/share-with-community';

export function DealerSelection({
  selectedDealer = null,
  closestDealers = [],
  onChangeDealer = null,
  dealerSelectError = false,
  disabled = false,
  mode = '',
}) {
  const [wasDealerChanged, setWasDealerChanged] = useState(false);
  const [showError, setShowError] = useState(false);

  if (!selectedDealer || !closestDealers || !closestDealers.length || (!!selectedDealer && wasDealerChanged)) {
    if (wasDealerChanged) setWasDealerChanged(false);
  }

  if (dealerSelectError && !showError && !selectedDealer) {
    setShowError(dealerSelectError);
  }

  /**
   * Selects option.
   * @param name
   * @param selectedOption
   */
  function selectOption(selected) {
    setShowError(false);
    if (onChangeDealer) {
      setWasDealerChanged(true);
      onChangeDealer(selected);
      EventToolbox.fireCustomEvent(PRICE_CHECKER_EVENTS.SELECT_DEALER, { dealer: get(selected, 'name', '') });
    }
  }

  const val = get(selectedDealer, 'id', '');
  const dealers = [{ id: 1, distanceLabel: 'This is not an offer from a dealer' }, ...closestDealers];
  const labelText = 'Who offered you this price quote?';

  return (
    <div className="text-gray-darker">
      <Fragment>
        <div className="mb-2">
          <StyledSelect
            value={val}
            options={dealers}
            onChange={selectOption}
            id={`${mode}dealer`}
            name={`${mode}dealer`}
            valueKey="id"
            labelKey="distanceLabel"
            labelText={labelText}
            labelClassName="small mb-0_5"
            toggle={showError ? TOGGLE_ERROR_MSG : TOGGLE_MSG}
            inputClassName={classnames('form-control py-0_5 pe-2_5 size-16 text-start mb-1_5 py-0_5', {
              'text-gray-darker': !showError,
              'text-danger has-danger': showError,
            })}
            optionClassName="text-gray-darker"
            disabled={disabled}
            data-testid="select-dealer"
          />
        </div>
      </Fragment>
    </div>
  );
}

DealerSelection.propTypes = {
  selectedDealer: PropTypes.shape({}),
  closestDealers: PropTypes.arrayOf(PropTypes.shape({})),
  onChangeDealer: PropTypes.func,
  dealerSelectError: PropTypes.bool,
  disabled: PropTypes.bool,
  mode: PropTypes.string,
};
